import { render, staticRenderFns } from "./existencia-en-stock.vue?vue&type=template&id=2aef7f49"
import script from "./existencia-en-stock.vue?vue&type=script&lang=js"
export * from "./existencia-en-stock.vue?vue&type=script&lang=js"
import style0 from "./existencia-en-stock.vue?vue&type=style&index=0&id=2aef7f49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports